import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { loginApi } from '../http/http';
import { removeUserDetails } from '../store/slices/userSlice';

const Auth = ({ children }) => {
    const { userDetails } = useSelector(state => state?.persisted?.userSlice);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    // const [loading,setLoading]=useState(true);

    const handleCheckSubscription = async () => {
        try {
            const response = await loginApi(userDetails?.msisdn);
        } catch (error) {
            if (error?.response?.status == 403) {
                dispatch(removeUserDetails());
                navigate("/");
            }

            if (error?.response?.data?.error?.status == 0) {
                dispatch(removeUserDetails());
                navigate("/");
            }

            if (error?.response?.data?.error?.status == 1) {
                dispatch(removeUserDetails());
                navigate("/");
            }
        }
    }

    useEffect(() => {
        if (!userDetails?.token) {
            navigate("/");
        }
        else {
            // setLoading(false);
            handleCheckSubscription();
        }
    }, []);
    return (
        <>
            {children}
        </>
    )
}

export default Auth